import { ActionListItem, LinkButton, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  setting: string;
  value: string;
  description?: string;
  children?: React.ReactNode;
  expanded: boolean;
  testID: string;
  editText?: string;
  toggle: () => void;
}

export function SettingsEditItem(props: Props) {
  const { t } = useTranslation();
  const {
    setting,
    value,
    description,
    expanded,
    toggle,
    children,
    testID,
    editText = t("Edit"),
  } = props;

  return (
    <>
      <ActionListItem
        displayAccessibility
        title={setting}
        trailing={
          <LinkButton
            textColor="text-weak"
            textStyle="global/body-secondary-link"
            onPress={toggle}
            testID={testID}
            aria-label={
              expanded
                ? t(`{{setting}} - Cancel`, { setting })
                : t(`{{setting}} - {{editText}}`, { setting, editText })
            }
          >
            {expanded ? <Trans>Cancel</Trans> : editText}
          </LinkButton>
        }
      >
        <Text
          style="form/body-secondary"
          color="text-weak"
          className={css(
            expanded &&
              !description && {
                marginTop: 0,
              },
            expanded &&
              description && {
                marginTop: "var(--space-4)",
              }
          )}
        >
          {!expanded ? value : description}
        </Text>
      </ActionListItem>
      {expanded && (
        <div
          className={css({
            paddingBottom: "var(--space-4)",
            paddingLeft: "var(--space-4)",
            paddingRight: "var(--space-4)",
          })}
        >
          {children}
        </div>
      )}
    </>
  );
}
